import { Validators } from "@angular/forms";
import { CustomRegExp } from "../../enums/regex.enum";
import { IFormData, IFormStructure } from "./form.component";
import { Injectable, inject } from "@angular/core";
import { CustomerService } from "../../../core/services/customer.service";
import { FacilitiesService } from "../../../core/services/facilities.service";
import { Observable, map, of } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class ResourcesStructure {
    private facilitiesService = inject(FacilitiesService);
    private customerService = inject(CustomerService);
    constructor() {

    }

    public formResourcesStructure: IFormResourceStructure = {
        customer: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'legal_entity',
                    title: 'LEGAL_ENTITY',
                    children: [
                        {
                            id: 'tax_data',
                            title: 'TAX_DATA',
                            requiredToSaveDraft: 'businessName',
                            inputs: [
                                {
                                    id: 'businessName',
                                    type: 'input' as 'input',
                                    length: 6,
                                    label: 'BUSINESS_NAME',
                                    validators: [
                                        Validators.required,
                                        Validators.pattern(CustomRegExp.BUSINESS_NAME),
                                    ],
                                    placeholder: 'Azienda S.R.L.',
                                },
                                {
                                    id: 'vatNumber',
                                    type: 'input' as 'input',
                                    length: 3,
                                    label: 'VAT',
                                    validators: [
                                        Validators.required,
                                        Validators.pattern(CustomRegExp.VAT),
                                    ],
                                    placeholder: '02539330221',
                                    inputRule: 'number'
                                },
                                {
                                    id: 'taxCode',
                                    type: 'input' as 'input',
                                    length: 3,
                                    label: 'TAX_CODE',
                                    validators: [Validators.pattern(CustomRegExp.VAT)],
                                    placeholder: '02539330221',
                                    inputRule: 'number'
                                },
                                {
                                    id: 'pec',
                                    type: 'input' as 'input',
                                    length: 3,
                                    label: 'PEC',
                                    validators: [
                                        Validators.pattern(CustomRegExp.PEC),
                                    ],
                                    placeholder: 'azienda@pec.it',
                                },
                                {
                                    id: 'recipientCode',
                                    type: 'input' as 'input',
                                    length: 3,
                                    label: 'RECIPIENT_CODE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.RECIPIENT_CODE),
                                    ],
                                    placeholder: 'A1B2C3D',
                                    inputRule: 'upperCase'
                                },
                            ],
                        },
                        {
                            title: 'REGISTERED_OFFICE',
                            id: 'registered_office',
                            inputs: [
                                {
                                    id: 'street',
                                    type: 'input' as 'input',
                                    length: 4,
                                    label: 'STREET',
                                    validators: [],
                                    placeholder: 'Via dei Mille',
                                },
                                {
                                    id: 'civic',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'CIVIC',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CIVIC),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'city',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'MUNICIPALITY',
                                    validators: [
                                    ],
                                    placeholder: '',
                                    inputRule: 'capitalize'
                                },
                                {
                                    id: 'postalCode',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'POSTAL_CODE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CAP),
                                    ],
                                    placeholder: '',
                                    inputRule: 'number'
                                },
                                {
                                    id: 'province',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'PROVINCE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.PROVINCE),
                                    ],
                                    placeholder: '',
                                    inputRule: 'capitalize'
                                },
                                {
                                    id: 'country',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'COUNTRY',
                                    validators: [
                                        Validators.pattern(CustomRegExp.COUNTRY),
                                    ],
                                    placeholder: '',
                                    inputRule: 'capitalize'
                                },
                            ],
                        },
                        {
                            title: 'CONTACTS',
                            id: 'contacts',
                            inputs: [
                                {
                                    id: 'representative',
                                    type: 'input' as 'input',
                                    length: 6,
                                    label: 'REFERENT',
                                    validators: [],
                                    placeholder: 'Mario Rossi',
                                    inputRule: 'capitalize'
                                },
                                {
                                    id: 'email',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'EMAIL',
                                    validators: [Validators.pattern(CustomRegExp.EMAIL)],
                                    placeholder: 'email@mail.com',
                                    inputRule: 'noSpaces'
                                },
                                {
                                    id: 'phoneNumber',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'MOBILE_NUMBER',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                    inputRule: 'number'
                                },
                                {
                                    id: 'telephone',
                                    type: 'input' as 'input',
                                    length: 2,
                                    label: 'LANDLINE_PHONE',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                    inputRule: 'number'
                                },
                            ]
                        },
                        {
                            id: 'experimental_features',
                            title: 'EXPERIMENTAL_FEATURES',
                            superuserOnly: true,
                            inputs: [
                                {
                                    id: 'spatialTrackingEnabled',
                                    type: 'toggle',
                                    length: 6,
                                    rowSpan: 2,
                                    label: 'SPATIAL_TRACKING',
                                    description: 'SPATIAL_TRACKING_DESCRIPTION',
                                    inputValue: false
                                }
                            ]
                        },
                    ]
                }],
            }
        },
        organization: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'organization',
                    title: 'ORGANIZATION',
                    children: [
                        {
                            id: 'organization_name',
                            title: 'ORGANIZATION_NAME',
                            requiredToSaveDraft: 'business_name',
                            inputs: [
                                {
                                    id: 'name',
                                    type: 'input',
                                    length: 6,
                                    label: 'ORGANIZATION_NAME_ALIAS',
                                    validators: [
                                        Validators.required,
                                        Validators.pattern(CustomRegExp.BUSINESS_NAME),
                                    ],
                                    placeholder: 'Nome organizzazione',
                                },
                            ],
                        },
                        {
                            id: 'organization_address',
                            title: 'ORGANIZATION_ADDRESS',
                            inputs: [
                                {
                                    id: 'org_to_business_same_address',
                                    type: 'checkbox',
                                    label: 'ORG_TO_BUSINESS_SAME_ADDRESS',
                                    completeSection: true,
                                    length: 6,
                                },
                                {
                                    id: 'street',
                                    type: 'input',
                                    length: 4,
                                    label: 'STREET',
                                    validators: [],
                                    placeholder: 'Via dei Mille',
                                },
                                {
                                    id: 'civic',
                                    type: 'input',
                                    length: 2,
                                    label: 'CIVIC',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CIVIC),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'city',
                                    type: 'input',
                                    length: 2,
                                    label: 'MUNICIPALITY',
                                    validators: [
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'postalCode',
                                    type: 'input',
                                    length: 2,
                                    label: 'POSTAL_CODE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CAP),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'province',
                                    type: 'input',
                                    length: 2,
                                    label: 'PROVINCE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.PROVINCE),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'country',
                                    type: 'input',
                                    length: 2,
                                    label: 'COUNTRY',
                                    validators: [
                                        Validators.pattern(CustomRegExp.COUNTRY),
                                    ],
                                    placeholder: '',
                                },
                            ],
                        }, {
                            title: 'CONTACTS',
                            id: 'contacts',
                            inputs: [
                                {
                                    id: 'contactToBusinessContact',
                                    type: 'checkbox',
                                    label: 'CONTACT_TO_BUSINESS_CONTACT',
                                    completeSection: true,
                                    length: 6,
                                },
                                {
                                    id: 'representative',
                                    type: 'input',
                                    length: 3,
                                    label: 'REFERENT',
                                    validators: [],
                                    placeholder: 'Mario Rossi',
                                },
                                {
                                    id: 'email',
                                    type: 'input',
                                    length: 3,
                                    label: 'EMAIL',
                                    validators: [Validators.pattern(CustomRegExp.EMAIL)],
                                    placeholder: 'email@mail.com',
                                    inputRule: 'noSpaces'
                                },
                                {
                                    id: 'phoneNumber',
                                    type: 'input',
                                    length: 3,
                                    label: 'MOBILE_NUMBER',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                },
                                {
                                    id: 'telephone',
                                    type: 'input',
                                    length: 3,
                                    label: 'LANDLINE_PHONE',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                },
                            ],
                        }
                    ],
                }]
            }
        },
        structure: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'ward',
                    title: 'WARD',
                    children: [
                        {
                            id: 'wardName',
                            title: 'WARD_NAME',
                            requiredToSaveDraft: 'wardName',
                            inputs: [
                                {
                                    id: 'name',
                                    type: 'input',
                                    length: 6,
                                    label: 'WARD_NAME',
                                    validators: [
                                        Validators.required
                                    ],
                                    placeholder: 'Nome Unità',
                                },
                            ],
                        }
                    ],
                }, {
                    id: 'rooms',
                    title: 'ROOMS',
                    categoryLabel: "ROOM",
                    dynamicChildren: true,
                    children: [
                        {
                            id: 'room',
                            title: 'ROOM',
                            childrenType: 'accordion',
                            rowSpan: 1,
                            isAccordionOpen: true,
                            inputs: [
                                {
                                    id: 'name',
                                    type: 'input',
                                    length: 6,
                                    label: 'ROOM_NAME',
                                    validators: [
                                        Validators.required,
                                    ],
                                    placeholder: 'Nome/numero stanza',
                                }, {
                                    id: 'beds',
                                    type: 'inputArray',
                                    buttonLabel: "Aggiungi Letto",
                                    inputs: [{
                                        id: 'name',
                                        type: 'input',
                                        length: 2,
                                        label: 'BED_NUMBER',
                                        validators: [
                                            Validators.required,
                                        ],
                                        placeholder: 'Numero letto',
                                    }]
                                }
                            ],
                        }
                    ]
                }]
            }
        },
        building: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'building',
                    title: 'BUILDING',
                    categoryLabel: "BUILDING",
                    children: [
                        {
                            id: 'buildingName',
                            title: 'GENERIC_NAME',
                            inputs: [
                                {
                                    id: 'name',
                                    type: 'input',
                                    length: 6,
                                    label: 'BUILDING_NAME',
                                    validators: [
                                        Validators.required,
                                        Validators.pattern(CustomRegExp.BUSINESS_NAME),
                                    ],
                                    placeholder: 'Nome organizzazione',
                                },
                            ],
                        },
                        {
                            id: 'building_address',
                            title: 'ADDRESS',
                            inputs: [
                                {
                                    id: 'building_to_org_same_address',
                                    type: 'checkbox',
                                    label: 'BUILDING_TO_ORG_SAME_ADDRESS',
                                    completeSection: true,
                                    length: 6,
                                },
                                {
                                    id: 'street',
                                    type: 'input',
                                    length: 4,
                                    label: 'STREET',
                                    validators: [],
                                    placeholder: 'Via dei Mille',
                                },
                                {
                                    id: 'civic',
                                    type: 'input',
                                    length: 2,
                                    label: 'CIVIC',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CIVIC),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'city',
                                    type: 'input',
                                    length: 2,
                                    label: 'MUNICIPALITY',
                                    validators: [
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'postalCode',
                                    type: 'input',
                                    length: 2,
                                    label: 'POSTAL_CODE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.CAP),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'province',
                                    type: 'input',
                                    length: 2,
                                    label: 'PROVINCE',
                                    validators: [
                                        Validators.pattern(CustomRegExp.PROVINCE),
                                    ],
                                    placeholder: '',
                                },
                                {
                                    id: 'country',
                                    type: 'input',
                                    length: 2,
                                    label: 'COUNTRY',
                                    validators: [
                                        Validators.pattern(CustomRegExp.COUNTRY),
                                    ],
                                    placeholder: '',
                                },
                            ],
                        }, {
                            title: 'CONTACTS',
                            id: 'contacts',
                            inputs: [
                                {
                                    id: 'representative',
                                    type: 'input',
                                    length: 3,
                                    label: 'REFERENT',
                                    validators: [],
                                    placeholder: 'Mario Rossi',
                                },
                                {
                                    id: 'email',
                                    type: 'input',
                                    length: 3,
                                    label: 'EMAIL',
                                    validators: [Validators.pattern(CustomRegExp.EMAIL)],
                                    placeholder: 'email@mail.com',
                                    inputRule: 'noSpaces'
                                },
                                {
                                    id: 'phoneNumber',
                                    type: 'input',
                                    length: 3,
                                    label: 'MOBILE_NUMBER',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                },
                                {
                                    id: 'telephone',
                                    type: 'input',
                                    length: 3,
                                    label: 'LANDLINE_PHONE',
                                    validators: [Validators.pattern(CustomRegExp.PHONE_NUMBER)],
                                    placeholder: '',
                                },
                            ]
                        }
                    ]
                }]
            }
        },
        user: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'user',
                    title: 'SECTION_TITLE.USER',
                    children: [
                        {
                            id: 'user_role',
                            title: 'INPUT_GROUP_TITLE.USER_ROLE',
                            inputs: [
                                {
                                    id: 'role',
                                    type: 'select',
                                    length: 6,
                                    label: 'ROLE',
                                    validators: [Validators.required],
                                    values: [
                                        {
                                            id: 'superuser',
                                            label: 'SUPER_USER'
                                        }, {
                                            id: 'localadmin',
                                            label: 'LOCAL_ADMIN'
                                        }, {
                                            id: 'user',
                                            label: 'AGENT'
                                        }
                                    ]
                                }
                            ],
                        },
                        {
                            id: 'personal_data',
                            title: 'INPUT_GROUP_TITLE.PERSONAL_DATA',
                            requiredToSaveDraft: 'name',
                            inputs: [
                                {
                                    id: 'name',
                                    type: 'input',
                                    length: 2,
                                    label: 'NAME',
                                    validators: [
                                        Validators.required,
                                    ],
                                    inputRule: 'capitalize',
                                    placeholder: 'Mario',
                                }, {
                                    id: 'lastname',
                                    type: 'input',
                                    length: 2,
                                    label: 'SURNAME',
                                    validators: [
                                        Validators.required,
                                    ],
                                    inputRule: 'capitalize',
                                    placeholder: 'Rossi',
                                }
                            ],
                        },
                        {
                            title: 'CONTACTS',
                            id: 'contacts',
                            inputs: [
                                {
                                    id: 'email',
                                    type: 'input',
                                    disableOnEdit: true,
                                    length: 6,
                                    label: 'EMAIL',
                                    validators: [Validators.pattern(CustomRegExp.EMAIL), Validators.required],
                                    placeholder: 'email@mail.com',
                                    inputRule: 'noSpaces'
                                }
                            ],
                        },
                        {
                            title: 'INPUT_GROUP_TITLE.ASSOCIATED_ORGANIZATION',
                            id: 'associated_organization',
                            disabledOn: {
                                childId: 'user_role',
                                inputId: 'role',
                                value: 'superuser'
                            },
                            inputs: [
                                {
                                    id: 'customerId',
                                    type: 'autocomplete',
                                    length: 3,
                                    label: 'CUSTOMER',
                                    validators: [Validators.required],
                                    suggestedItems: this.customerService.loadCustomers$().pipe(
                                        map((data) => (data || []).map((item: any) => ({ id: item.id, label: item.businessName })))
                                    )
                                }, {
                                    id: 'organizationId',
                                    type: 'select',
                                    length: 3,
                                    label: 'ORGANIZATION',
                                    values: [],
                                    validators: [
                                        Validators.required,
                                    ],
                                    disableTranslation: true,
                                    loadOn: 'customerId',
                                    loader: (customerId: number | string | undefined): Observable<{ id: string, label: string }[]> => this.facilitiesService.getOrganization$(customerId as number).pipe(map((data) => data.map((item) => ({ id: item.id, label: item.name }))))
                                }
                            ],
                        },
                    ],
                }],
            }
        },
        deviceLink: {
            formStructure: {
                formType: 'simple',
                structure: [{
                    id: 'deviceLink',
                    title: 'SECTION_TITLE.LINK_DEVICE',
                    children: [
                        {
                            title: 'INPUT_GROUP_TITLE.LINK_DEVICE',
                            id: 'deviceLink',
                            inputs: [
                                {
                                    id: 'building',
                                    type: 'select',
                                    length: 6,
                                    label: 'BUILDING',
                                    disableTranslation: true,
                                    loader: (): Observable<{ id: string, label: string }[]> => this.facilitiesService.getBuildings$().pipe(
                                        map((data) => data.map((item) => ({ id: item.id!, label: item.name! })))
                                    ),
                                    values: []
                                }, {
                                    id: 'unit',
                                    type: 'select',
                                    length: 6,
                                    label: 'UNIT',
                                    disableTranslation: true,
                                    loader: (buildingId: string | number | undefined): Observable<{ id: string, label: string }[]> => buildingId ? this.facilitiesService.getUnits$(buildingId as string).pipe(
                                        map((data) => data.map((item) => ({ id: item.id!, label: item.name! })))
                                    ) : of([]),
                                    values: []
                                }, {
                                    id: 'room',
                                    type: 'select',
                                    length: 6,
                                    label: 'ROOM',
                                    disableTranslation: true,
                                    loader: (unitId: string | number | undefined): Observable<{ id: string, label: string }[]> => unitId ? this.facilitiesService.getRooms$(unitId as string).pipe(
                                        map((data) => data.map((item) => ({ id: item.id!, label: item.name! })))
                                    ) : of([]),
                                    values: []
                                }
                            ],
                        }
                    ],
                }]
            }
        },
    }

}

interface IFormResourceStructure {
    [key: string]: {
        formStructure: IFormData;
        showGenerateDataButton?: boolean;
        dynamicSection?: IFormStructure
    };
}